import addAttributeToEmailField from './addAttributeToEmailField';
import addForToLabel from './addForToLabel';
import applyAttributes from './applyAttributes';
import clearForm from './clearForm';
import inputImageToButton from './inputImageToButton';
import labelToPlaceholder from './labelToPlaceholder';
import labelToSelectOption from './labelToSelectOption';
import linkSubmitToButton from './linkSubmitToButton';
import normalizeHiddenFields from './normalizeHiddenFields';
import textNodeToPlaceholder from './textNodeToPlaceholder';

export {
  addAttributeToEmailField,
  addForToLabel,
  applyAttributes,
  clearForm,
  inputImageToButton,
  labelToPlaceholder,
  labelToSelectOption,
  linkSubmitToButton,
  normalizeHiddenFields,
  textNodeToPlaceholder,
};



/** WEBPACK FOOTER **
 ** ./src/helpers/form/filters/factories/index.js
 **/